import { Component, Input, OnInit } from '@angular/core';
import { BillingOrderControlCTAttachedFileService } from '../../../services/billing/billing-order-control-ctattached-file.service';
import { BillingCtAttachedFile } from '../../../model/billing/billing-ct-attached-file';
import { DownloadLocalFileService } from '../../../services/download-local-file.service';
import { NotificationToastService } from 'src/app/services/notification-toast.service';
 
@Component({
  selector: 'app-billing-orden-control-attached-file',
  templateUrl: './billing-orden-control-attached-file.component.html',
  styleUrls: ['./billing-orden-control-attached-file.component.css']
})
export class BillingOrdenControlAttachedFileComponent implements OnInit {

  @Input() medicalAppointmentId: number;
  files: BillingCtAttachedFile[];

  constructor(  private downloadLocalFileService: DownloadLocalFileService,
                private notificationToastService: NotificationToastService,
                private cTAttachedFileService: BillingOrderControlCTAttachedFileService) { }

  ngOnInit() {
    this.cTAttachedFileService
      .getCTAttachedFiles(this.medicalAppointmentId)
      .then(values => this.files = values);
  }

  async download( file: BillingCtAttachedFile ) {
    try {

      file.loading = true;
      const fileComplete = await this.cTAttachedFileService
        .getBase64CTAttachedFile(file.Id);

      this.downloadLocalFileService
          .downLoadFile(
            fileComplete.ArchivoBase64,
            fileComplete.Nombre,
            file.Extension);

    } catch ( err ) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Control órden');
    } finally {
      file.loading = false;
    }
  }

}
